import React from 'react';
import styled from 'styled-components';
import { Card, Title, Text, theme } from 'components';
import UploadDocuments from '../components/UploadDocuments';

type UploadDocumentsFormProps = {
  documents?: any[];
  setDocuments?: React.Dispatch<React.SetStateAction<any[]>>;
  documentListError: string;
};

const UploadDocumentsForm: React.FC<UploadDocumentsFormProps> = ({
  documents,
  setDocuments,
  documentListError,
}) => (
    <StyledUploadCard
      type="primary"
      title={
        <Title level={2} textAlign="center">
          Upload Listing Documents
        </Title>
      }
    >
      <UploadDocuments
        documents={documents}
        setDocuments={setDocuments}
        description="You may upload single or multiple files at a time."
        helperText={
          documentListError === 'listingAgreement' && (
            <StyledWarning type="secondary">
              You must have 1 document type selected as &apos;Listing
              Paperwork&apos; to continue.
            </StyledWarning>
          )
        }
      />
    </StyledUploadCard>
  );

const StyledUploadCard = styled(Card)`
  max-width: 600px;
  margin: auto;
`;

const StyledWarning = styled(Text)`
  && {
    color: ${theme.getColor('danger')};
    font-size: 1.2rem;
  }
`;

export default UploadDocumentsForm;
